import logo from './logo.svg';
import './App.css';
import Header from './Header';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from './Home';
import Shop from './Shop';
import { useEffect, useState } from 'react';
import About from './About';



const loadCart = JSON.parse(localStorage.getItem("cart") || "[]")

function App() {

  const [cart, setCart] = useState(loadCart);

   
    useEffect(() => {
        localStorage.setItem("cart", JSON.stringify(cart));
    }, [cart]);

  return (

    <div className="App" >
      <Router> 
          <Header cartQuantity={cart.length}/> 
          <Switch>
            <Route exact path="/">
              <Home/>
            </Route>
            
            <Route exact path="/shop">

              <Shop cart={cart} setCart={setCart} page="shop"/>
            </Route>

            <Route exact path="/shop/cart">

              <Shop cart={cart} setCart={setCart} page="cart"/>
            </Route>
            <Route exact path="/about">
              <About/>
            </Route>
          </Switch>
      </Router>
      
    </div>
  );
}

export default App;
